import { Injectable, Inject, Optional } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { AI_ONBOARDING_CONFIG, AiOnboardingConfig } from '../../ai-onboarding.config';

@Injectable({
  providedIn: 'root'
})
export class GoogleMapsLoaderService {
  private loaderPromise: Promise<void> | null = null;
  private readonly apiKey: string;

  constructor(
    @Optional() @Inject(AI_ONBOARDING_CONFIG) config?: AiOnboardingConfig
  ) {
    // Priority: injected config > environment > none
    this.apiKey = config?.googleMapsApiKey || environment.googleMapApiKey || '';
  }

  load(): Promise<void> {
    if (this.loaderPromise) {
      return this.loaderPromise;
    }

    this.loaderPromise = new Promise((resolve, reject) => {
      if ((window as any).google && (window as any).google.maps) {
        resolve();
        return;
      }

      if (!this.apiKey || this.apiKey === 'YOUR_API_KEY_HERE') {
          console.warn('Google Maps API Key not configured. Using Mock Mode.');
          // We reject here so consumers can fall back to mocks, or we could just resolve and let the consumer check for 'google' on window.
          // Let's resolve but log a warning, consumers should check window.google.
          resolve();
          return;
      }

      const script = document.createElement('script');
      script.src = `https://maps.googleapis.com/maps/api/js?key=${this.apiKey}&libraries=places,geometry`;
      script.async = true;
      script.defer = true;
      script.onload = () => resolve();
      script.onerror = (err) => reject(err);
      document.body.appendChild(script);
    });

    return this.loaderPromise;
  }

  /** Returns the configured API key (for use in URL generation) */
  getApiKey(): string {
    return this.apiKey;
  }

  get isLoaded(): boolean {
      return !!((window as any).google && (window as any).google.maps);
  }
}
